"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _theme = require("@zip/theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgAutopay = function SvgAutopay(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var theme = (0, _react.useTheme)();

  switch (theme.name) {
    case _theme.fearlessBusiness.name:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 60 60",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsxs)("g", {
          clipPath: "url(#autopay_svg__clip0)",
          children: [(0, _jsxRuntime.jsx)("path", {
            d: "M30.012 46.848c-.903 0-1.818-.075-2.72-.221a16.697 16.697 0 01-10.93-6.77l2.098-1.51a14.126 14.126 0 009.248 5.729c3.748.615 7.533-.29 10.59-2.488a14.17 14.17 0 005.676-8.926l2.539.477a16.73 16.73 0 01-6.705 10.546 16.671 16.671 0 01-9.796 3.163zM15.972 27.756l-2.558-.364c.73-4.48 3.136-8.362 6.778-10.981a16.76 16.76 0 0112.517-2.942c4.277.7 8.07 2.986 10.683 6.436l-2.06 1.56a14.144 14.144 0 00-9.039-5.445 14.167 14.167 0 00-10.592 2.488 14.12 14.12 0 00-5.729 9.248z",
            fill: "#6EC8FF"
          }), (0, _jsxRuntime.jsx)("path", {
            d: "M47.794 35.587l-2.815-2.814-2.814 2.813a1.293 1.293 0 01-1.827-1.827l4.64-4.64 4.643 4.64a1.29 1.29 0 010 1.828 1.294 1.294 0 01-1.828 0zM15.021 30.952l-4.642-4.64a1.291 1.291 0 111.827-1.828l2.815 2.813 2.814-2.813a1.293 1.293 0 011.827 0 1.293 1.293 0 010 1.827l-4.64 4.64z",
            fill: "#86D1FF"
          })]
        }), (0, _jsxRuntime.jsx)("defs", {
          children: (0, _jsxRuntime.jsx)("clipPath", {
            id: "autopay_svg__clip0",
            children: (0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              transform: "translate(10 10)",
              d: "M0 0h40v40H0z"
            })
          })
        })]
      }));

    default:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 60 60",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsxs)("g", {
          clipPath: "url(#autopay_svg__clip0)",
          children: [(0, _jsxRuntime.jsx)("path", {
            d: "M30.012 46.848c-.903 0-1.818-.075-2.72-.221a16.697 16.697 0 01-10.93-6.77l2.098-1.51a14.126 14.126 0 009.248 5.729c3.748.615 7.533-.29 10.59-2.488a14.17 14.17 0 005.676-8.926l2.539.477a16.73 16.73 0 01-6.705 10.546 16.671 16.671 0 01-9.796 3.163zM15.972 27.756l-2.558-.364c.73-4.48 3.136-8.362 6.778-10.981a16.76 16.76 0 0112.517-2.942c4.277.7 8.07 2.986 10.683 6.436l-2.06 1.56a14.144 14.144 0 00-9.039-5.445 14.167 14.167 0 00-10.592 2.488 14.12 14.12 0 00-5.729 9.248z",
            fill: "#AA8FFF"
          }), (0, _jsxRuntime.jsx)("path", {
            d: "M47.794 35.587l-2.815-2.814-2.814 2.813a1.293 1.293 0 01-1.827-1.827l4.64-4.64 4.643 4.64a1.29 1.29 0 010 1.828 1.294 1.294 0 01-1.828 0zM15.021 30.952l-4.642-4.64a1.291 1.291 0 111.827-1.828l2.815 2.813 2.814-2.813a1.293 1.293 0 011.827 0 1.293 1.293 0 010 1.827l-4.64 4.64z",
            fill: "#C9B3FF"
          })]
        }), (0, _jsxRuntime.jsx)("defs", {
          children: (0, _jsxRuntime.jsx)("clipPath", {
            id: "autopay_svg__clip0",
            children: (0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              transform: "translate(10 10)",
              d: "M0 0h40v40H0z"
            })
          })
        })]
      }));
  }
};

var _default = SvgAutopay;
exports["default"] = _default;